import { AUTHORIZATION_HEADER } from '../../../../../../../../../../src/authorization';
import { send } from '../../../../../../../../../../src/network';
import { type Cart } from '../../../../../../../../../../src/types/Cart';

export interface DeleteProductFromBundleMutationParams {
  bundleId: number;
  productId: number;
  reasonId?: number;
}

export async function deleteProductFromBundle({
  bundleId,
  productId,
  reasonId,
}: DeleteProductFromBundleMutationParams) {
  const query = new URLSearchParams();
  if (reasonId !== undefined) {
    query.set('reason_id', reasonId.toString());
  }
  return send<Cart>({
    path: `/api/v2/customers/self/cart/bundles/${bundleId}/products/${productId}/`,
    method: 'DELETE',
    query: query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
